module.exports = __webpack_public_path__ + "img/icon_check_dark.1c84772f.svg";